import './DailyMessage.scss';
import React, { useState } from 'react';
import APIResponse from '../../../../templates/components/APIResponse';
import DailyMessageService from '../../../../../services/api/daily-message.service';
import moment from "moment";
import DimLoader from '../../../../templates/components/DimLoader';
import { Message } from 'semantic-ui-react'
const DailyMessage = (props) => {
  const [dailyMessage, setDailyMessage] = useState(props.initialData || []);
  const [showForm, setShowForm] = useState(false)
  const [hasSettingsAllSchedulingAccess, setHasSettingsAllSchedulingAccess] = useState(props?.permission || false);
  const [selectedMessage, setSelectedMessage] = useState();
  const [apiResponse, setApiResponse] = useState()
  const [isLoader, setIsLoader] = useState(props?.isLoader || false)

  const onSuccess = (message) => {
    setSelectedMessage()
    setShowForm(false)
    if (props.refresh) {
      props.refresh()
    }
    if (props.onClose) {
      props.onClose()
    }
    if (props.exitHandler) {
      props.exitHandler()
    }
  }

  const submitHandler = () => {
    setIsLoader(true)
    //console.log("selectedMessage::::" +JSON.stringify(selectedMessage))
    if (selectedMessage.dailyMessageId) {
      DailyMessageService.updateDailyMessages(selectedMessage, selectedMessage.dailyMessageId)
        .then(response => {
          setApiResponse(response);
        })
        .catch(error => {
          setApiResponse(error);
        })
        .finally(() => {
          setIsLoader(false);
        });
    } else {
      const reqObj = {
        dailyMessage: selectedMessage.dailyMessage,
        practiceLocationId: props.practiceLocationId,
        date: moment(props.date).format("YYYY-MM-DD"),
      }
      DailyMessageService.addDailyMessage(reqObj)
        .then(response => {
          setApiResponse(response);
        })
        .catch(error => {
          setApiResponse(error);
        })
        .finally(() => {
          setIsLoader(false);
        });
    }
  }

  const inputChange = (e) => {
    let newStateObject = { ...selectedMessage };
    newStateObject[e.target.name] = e.target.value
    setSelectedMessage(newStateObject);
  }

  return (
    <div>
      {isLoader && <DimLoader />}
      {(!dailyMessage || dailyMessage.length < 1) && !isLoader && !showForm &&
        <Message visible><span>There is no message available for this date. <a hidden={!hasSettingsAllSchedulingAccess} href="#" onClick={e => { e.preventDefault(); setSelectedMessage(); setShowForm(true) }}>Add a Message</a></span></Message>}
      {dailyMessage && dailyMessage.length > 0 && !showForm &&
        <Message visible>
          {dailyMessage[0].dailyMessage != null ? dailyMessage[0].dailyMessage : '--'}
          {hasSettingsAllSchedulingAccess &&
            <button className='btn btn-transparent'
              style={{ padding: "0rem 1rem" }}
              onClick={e => { e.preventDefault(); setSelectedMessage(dailyMessage[0]); return setShowForm(true) }} title="Edit Message">
              <i className='icon pencil' />
            </button>
          }
        </Message>}

      {showForm && (
        <>
          <div className="field sixteen wide column mt-1">
            <textarea placeholder="Message"
              className="form-control"
              value={selectedMessage && selectedMessage.dailyMessage ? selectedMessage.dailyMessage : ""}
              onChange={e => {
                e.preventDefault();
                inputChange(e)
              }}
              name="dailyMessage"
              rows={2}
            />
          </div>
          <div className="mt-1 mb-2 d-flex justify-content-between modal-button-bar">
            <div className='col-auto'>
              <button className="btn btn-primary" disabled={!selectedMessage?.dailyMessage} onClick={e => {
                e.preventDefault();
                submitHandler(selectedMessage)
              }}>{selectedMessage?.dailyMessageId ? 'Update' : 'Add'}</button>
            </div>
            <div className="col-auto">
              <button className="btn btn-secondary" onClick={e => { e.preventDefault(); setShowForm(false) }}>Close</button>
            </div>
          </div>
        </>
      )}
      <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
    </div>
  );
};

export default DailyMessage;